import * as React from 'react';
import {
    Button,
    ButtonGroup,
    FormGroup,
    FormControl,
    Row,
    Col,
    ControlLabel
} from 'react-bootstrap';
import Dropzone from '../../Dropzone';
import { Translate } from '../../../../shared/LanguageService';
import { IFileInfo } from '../Entities';

interface IProps {
    selectedFile?: string;
    onSelectedFileChanged?: (e: any) => void;
    files?: IFileInfo[];
    onDeleteFile?: () => void;
    onFileUploadCompleted?: (response: any) => void;

    selectedSecondaryFile?: string;
    onSelectedSecondaryFileChanged?: (e: any) => void;
    secondaryFiles?: IFileInfo[];
    onDeleteSecondaryFile?: () => void;
    onSecondaryFileUploadCompleted?: (response: any) => void;

    dropzoneId: string;
    actionUrl: string;
    actionUrlToCustomer: string;
    upload: boolean;
    uploadToCustomer: boolean;
    onUploadCompleted: () => void;
    onUpload: () => void;
    onUploadToCustomer: () => void;

    title: string;
    readOnly?: boolean;
}

const ExternalFilesForm = (props: IProps) => {
    const { apiUrl } = window.appConfig;
    const baseUrl = `${apiUrl}`;

    return (
        <fieldset className="planeditor-fieldset">
            <legend>{props.title}</legend>
            <div>
                {props.actionUrlToCustomer && props.onUploadToCustomer && (
                    <div>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('plan/external-files/internal/label')}
                                    </ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        multiple
                                        value={
                                            props.selectedFile !== null ? [props.selectedFile] : ''
                                        }
                                        onChange={props.onSelectedFileChanged}
                                    >
                                        {props.files &&
                                            props.files.map((file, index) => (
                                                <option
                                                    key={'externalfile-' + index}
                                                    value={index.toString()}
                                                >
                                                    {file.filename}
                                                </option>
                                            ))}
                                    </FormControl>
                                </FormGroup>
                                <FormGroup className="pull-right button-row">
                                    <ButtonGroup bsSize="sm">
                                        {props.selectedFile && (
                                            <a
                                                className="btn btn-info"
                                                title={Translate(
                                                    'order/plan/internal-exernal-file/download-button'
                                                )}
                                                href={`${baseUrl}/file/${
                                                    props.files[props.selectedFile].fileReference
                                                }`}
                                                target="_blank"
                                            >
                                                <i className="material-icons md-18">
                                                    cloud_download
                                                </i>{' '}
                                                {Translate(
                                                    'order/plan/internal-exernal-file/download-button'
                                                )}
                                            </a>
                                        )}
                                        <Button
                                            bsStyle="danger"
                                            bsSize="sm"
                                            onClick={props.onDeleteFile}
                                        >
                                            <i className="material-icons">delete_forever</i>
                                            {Translate('plan/external-files/delete-button')}
                                        </Button>
                                    </ButtonGroup>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>
                                        {Translate('plan/external-files/delivery/label')}
                                    </ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        multiple
                                        value={
                                            props.selectedSecondaryFile !== null
                                                ? [props.selectedSecondaryFile]
                                                : ''
                                        }
                                        onChange={props.onSelectedSecondaryFileChanged}
                                    >
                                        {props.secondaryFiles &&
                                            props.secondaryFiles.map((file, index) => (
                                                <option
                                                    key={'externalfile-' + index}
                                                    value={index.toString()}
                                                >
                                                    {file.filename}
                                                </option>
                                            ))}
                                    </FormControl>
                                </FormGroup>
                                <FormGroup className="pull-right">
                                    <Button
                                        bsStyle="danger"
                                        bsSize="sm"
                                        onClick={props.onDeleteSecondaryFile}
                                    >
                                        <i className="material-icons">delete_forever</i>
                                        {Translate('plan/external-files/delete-button')}
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <div className="button-bar-below">
                                    <div className="content-row">
                                        <Dropzone
                                            dropzoneHtmlId={props.dropzoneId}
                                            actionUrl={props.actionUrl}
                                            upload={props.upload}
                                            onUploadCompleted={props.onUploadCompleted}
                                            onFileUploadCompleted={props.onFileUploadCompleted}
                                            uploadMultiple={true}
                                            removeFileAfterSuccess={true}
                                            acceptedFiles={null}
                                        />
                                    </div>
                                    <div className="button-row">
                                        <ButtonGroup bsSize="sm">
                                            <Button bsStyle="info" onClick={props.onUpload}>
                                                <i className="material-icons">cloud_upload</i>{' '}
                                                {Translate('plan/external-files/upload-button')}
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="button-bar-below">
                                    <div className="content-row">
                                        <Dropzone
                                            dropzoneHtmlId={props.dropzoneId + '-customer'}
                                            actionUrl={props.actionUrlToCustomer}
                                            upload={props.uploadToCustomer}
                                            onUploadCompleted={props.onUploadCompleted}
                                            onFileUploadCompleted={
                                                props.onSecondaryFileUploadCompleted
                                            }
                                            uploadMultiple={true}
                                            removeFileAfterSuccess={true}
                                            acceptedFiles="image/png,image/jpeg,application/pdf"
                                        />
                                    </div>
                                    <div className="button-row">
                                        <ButtonGroup bsSize="sm">
                                            <Button
                                                bsStyle="info"
                                                onClick={props.onUploadToCustomer}
                                            >
                                                <i className="material-icons">cloud_upload</i>{' '}
                                                {Translate(
                                                    'plan/external-files/upload-to-customer-button'
                                                )}
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )}

                {!props.actionUrlToCustomer && !props.onUploadToCustomer && (
                    <div>
                        <Col sm={5}>
                            <FormGroup>
                                <ControlLabel>
                                    {Translate('plan/external-files/storey/label')}
                                </ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    multiple
                                    value={props.selectedFile !== null ? [props.selectedFile] : ''}
                                    onChange={props.onSelectedFileChanged}
                                >
                                    {props.files &&
                                        props.files.map((file, index) => (
                                            <option
                                                key={'externalfile-' + index}
                                                value={index.toString()}
                                            >
                                                {file.filename}
                                            </option>
                                        ))}
                                </FormControl>
                            </FormGroup>
                            <ButtonGroup className="pull-right" bsSize="sm">
                                {props.selectedFile && (
                                    <a
                                        className="btn btn-info"
                                        title={Translate(
                                            'order/plan/internal-exernal-file/download-button'
                                        )}
                                        href={`${baseUrl}/file/${
                                            props.files[props.selectedFile].fileReference
                                        }`}
                                        target="_blank"
                                    >
                                        <i className="material-icons md-18">cloud_download</i>{' '}
                                        {Translate(
                                            'order/plan/internal-exernal-file/download-button'
                                        )}
                                    </a>
                                )}
                                {!props.readOnly && (
                                    <Button bsStyle="danger" onClick={props.onDeleteFile}>
                                        <i className="material-icons">delete_forever</i>
                                        {Translate('plan/external-files/delete-button')}
                                    </Button>
                                )}
                            </ButtonGroup>
                        </Col>
                        <Col sm={7}>
                            {!props.readOnly && (
                                <div className="button-bar-below">
                                    <div className="content-row">
                                        <Dropzone
                                            dropzoneHtmlId={props.dropzoneId}
                                            actionUrl={props.actionUrl}
                                            upload={props.upload}
                                            onUploadCompleted={props.onUploadCompleted}
                                            onFileUploadCompleted={props.onFileUploadCompleted}
                                            uploadMultiple={true}
                                            removeFileAfterSuccess={true}
                                            acceptedFiles={null}
                                        />
                                    </div>
                                    <div className="button-row">
                                        <ButtonGroup bsSize="sm">
                                            <Button bsStyle="info" onClick={props.onUpload}>
                                                <i className="material-icons">cloud_upload</i>{' '}
                                                {Translate('plan/external-files/upload-button')}
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </div>
                )}
            </div>
        </fieldset>
    );
};

export default ExternalFilesForm;
